export interface ProductImage {
	url: string;
	comment: string;
	links: ProductImageLink[];
	subject: ProductImageSubject;
}

export interface ProductImageLink {
	href: string;
	rel: string;
}

export enum ProductImageSubject {
	ATMOSPHERE = 'ATMOSPHERE',
	FACADE = 'FACADE',
	FACILITIES = 'FACILITIES',
	GARDEN_OR_TERRACE = 'GARDEN_OR_TERRACE',
	GASTRONOMY = 'GASTRONOMY',
	RECEPTION = 'RECEPTION',
	ROOM = 'ROOM',
	SANITARY = 'SANITARY',
}
